import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
* {
	font-family: 'Inter', sans-serif;
}
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
font-family: 'Inter', sans-serif;
font-size:12px;

.rubik-medium{
	font-weight: bold;

	color:#2E384D;
  }

.rubik-upper{
	color:#a7abb2;
	text-transform: uppercase;
	font-size:0.75em;
	letter-spacing: 1.12px;
}
 .rubik-regular{
	color:	#2E384D;
	font-size:0.875em;
	
 }
`;

export default GlobalStyle;

// import { createGlobalStyle } from 'styled-components';

// const GlobalStyle = createGlobalStyle`
// 	* {
// 		font-family: 'Inter', sans-serif;
// 	}
// 	body {
// 		background-color: #f1f4f6;
// 		border: 0;
// 		margin: 0;
// 		padding: 0;
// 	}
// `;

// export default GlobalStyle;
